import { Grid, Stack, Tab, Tabs, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import Editor from 'src/components/editor';
import Image from 'src/components/image/Image';
import Markdown from 'src/components/markdown';
import { GetVisitById } from 'woofwoof-api';
import DocumentCarousel from '../../visit/components/DocumentCarousel';
import { translateKey } from 'src/locales/translate';


const StyledMarkdown = styled(Markdown)(({ theme }) => ({
  '& *': {
    fontSize: `${theme.typography.body2.fontSize} !important`,
    color: `${theme.palette.text.secondary} !important`,
  },
}));

const TABS = [
  { value: 1, label: translateKey("visit.complaintsHeading") },
  { value: 2, label: translateKey("visit.tabInternalNotes") },
];

type OrganizationUpcomingVisitCardTabsProps = {
  visit: GetVisitById;
  isEditing?: boolean;
  internalNotes?: string;
  onInternalNotesChange?: (value: string) => void;
  activeTab?: number;
  onTabChange?: (value: number) => void;
};

export default function OrganizationUpcomingVisitCardTabs({
  visit,
  isEditing = false,
  internalNotes = '',
  onInternalNotesChange,
  activeTab,
  onTabChange,
}: OrganizationUpcomingVisitCardTabsProps) {
  const theme = useTheme();
  const [internalValue, setInternalValue] = useState(1);
  const value = activeTab ?? internalValue;
  const setValue = (v: number) => {
    setInternalValue(v);
    onTabChange?.(v);
  };

  return (
    <>
      <Grid item xs={12}>
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            borderWidth: '1px',
            borderColor: theme.palette.divider,
            borderBottomStyle: 'solid',
            gap: 2,
            mx: { xs: 2, sm: 2, md: 2, lg: 0 },
          }}
        >
          <Tabs value={value} onChange={(_, newValue) => setValue(newValue)}>
            {TABS.map((tab) => (
              <Tab
                key={tab.value}
                label={tab.label}
                value={tab.value}
                sx={{ fontSize: 14 }}
              />
            ))}
          </Tabs>
        </Stack>
      </Grid>
      <Grid item xs={12} pt={1}>
        {value === 1 && (
          <Stack sx={{ gap: 2, height: 1, minHeight: '125px' }}>
            <Stack sx={{ gap: 1, flex: 'auto' }}>
              <Typography variant="body2">{visit.description}</Typography>
            </Stack>
            {!!visit.documents.length && (
              <Stack sx={{ gap: 1 }}>
                <Typography variant="body2">{translateKey("quickBooking.attachments")}</Typography>
                <DocumentCarousel
                  documents={visit.documents as any}
                  visitId={visit.id}
                />
              </Stack>
            )}
          </Stack>
        )}
        {value === 2 && (
          <Stack sx={{ height: 1, minHeight: '125px' }}>
            {isEditing ? (
              <Editor
                simple
                id="edit-internal-notes-org-card"
                value={internalNotes}
                onChange={onInternalNotesChange || (() => {})}
                sx={{ height: '100%' }}
              />
            ) : (visit as any).internalNotes ? (
              <StyledMarkdown>{(visit as any).internalNotes}</StyledMarkdown>
            ) : (
              <Stack
                justifyContent="center"
                alignItems="center"
                gap={1}
                flex={1}
                height="100%"
                minHeight="200px"
              >
                <Image
                  disabledEffect
                  visibleByDefault
                  alt="brak notatek"
                  src="/assets/illustrations/laptop-paw-blue.svg"
                  sx={{ maxWidth: 120, paddingBottom: 1 }}
                />
                <Typography variant="body2" color="text.secondary">
                  Brak notatek
                </Typography>
              </Stack>
            )}
          </Stack>
        )}
      </Grid>
    </>
  );
}
